/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */

const initHeroScrollBannerObserver = () => {
  const heroSectionBlocks = document.querySelectorAll('.hero-section-block');
  if (!heroSectionBlocks || !heroSectionBlocks.length > 1) return;

  const useScrollSnapping = false; // to enable scroll snapping set this to true

  const hasNonSnappingContentAfter = true; // if page has content after hero section set this to true

  if (useScrollSnapping) {
    // to make scroll snapping with css work need to adjust some styles on the html,body,and main tags
    document.documentElement.classList.add('scroll-snapping');
  }

  // function used for setting up thresholds of the intersection observers
  // the more we have the more fluid the opacity changes on scroll will be
  const buildThresholdList = () => {
    const thresholds = [];
    const numSteps = 100;

    for (let i = 1.0; i <= numSteps; i += 1) {
      const ratio = i / numSteps;
      thresholds.push(ratio);
    }

    thresholds.push(0);
    return thresholds;
  };

  const handleIntersect = (entries) => {
    entries.forEach((entry) => {
      const { target, intersectionRatio, isIntersecting } = entry;
      // if (!isIntersecting) return;
      // TODO - if time allows, try handling buttons and headings seperately so buttons can be hidden closer to when they appear past their parent container
      const fadeElements = target.querySelectorAll('.fade-animation');
      fadeElements.forEach((fadeElement) => {
        // snapping accelerates the fade animation so setting thresholds to be faster when not using snapping
        const opacityAcceleration = useScrollSnapping ? 0.05 : 0.15;
        const fadeInThreshold = useScrollSnapping ? 0.85 : 0.85;
        const fadeOutThreshold = useScrollSnapping ? 0.45 : 0.75;
        intersectionRatio >= 0.5
          ? (fadeElement.style.opacity = intersectionRatio - opacityAcceleration)
          : (fadeElement.style.opacity = intersectionRatio + opacityAcceleration);

        if (intersectionRatio >= fadeInThreshold) {
          fadeElement.classList.remove('fade-out');
        }
        if (intersectionRatio <= fadeOutThreshold) {
          fadeElement.classList.add('fade-out');
        }
      });
    });
  };

  const handleLastIntersect = (entries) => {
    let lastTriggerPosition = 0;
    let direction = 'down';

    const setScrollDirection = (e) => {
      const { y } = e.boundingClientRect;
      if (y === 0) return;
      direction = lastTriggerPosition > y ? 'up' : 'down';
      lastTriggerPosition = y;
    };
    entries.forEach((entry) => {
      const { target, intersectionRatio, isIntersecting } = entry;
      if (!isIntersecting) return;
      setScrollDirection(entry);
      if (direction === 'down') {
        document.documentElement.classList.remove('scroll-snapping');
      } else {
        document.documentElement.classList.add('scroll-snapping');
      }
      target.scrollIntoView({ behavior: 'auto', block: 'start' });
    });
  };

  const heroSectionsObserver = new IntersectionObserver(handleIntersect, {
    threshold: buildThresholdList(),
  });

  heroSectionBlocks.forEach((section, sectionIndex, sectionsArray) => {
    heroSectionsObserver.observe(section);
    const needsContentAfterFix = () => useScrollSnapping && hasNonSnappingContentAfter;
    if (needsContentAfterFix() && sectionIndex === sectionsArray.length - 1) {
      const lastSectionObserver = new IntersectionObserver(handleLastIntersect, {
        threshold: 0.49,
      });
      lastSectionObserver.observe(section);
    }
  });
};

initHeroScrollBannerObserver();
